import { lazy } from "react";

const ActivityTypePage = lazy(() => import("./main"));
const CreateActivityTypePage = lazy(() => import("./create"));
const UpdateActivityTypePage = lazy(() => import("./update"));

export { ActivityTypePage, CreateActivityTypePage, UpdateActivityTypePage };
